import React from 'react';
import {asyncComponent} from 'react-async-component';
import Spinner from "../spinner";

export default asyncComponent({
  resolve: () => import('./MessageMockup'),
  LoadingComponent: () => <div className="message-editor-loader"><Spinner/></div>,
});
